
































































































import aggregatorModel from '@/components/Company/newCompany/companyInfo/forms/aggregatorModel.vue';
import IntermediarySelect from '@/components/Reusable/IntermediarySelect.vue';
import TaxpayerTypesSelect from '@/components/Reusable/TaxpayerTypesSelect.vue';
import {
  AggregatorModel,
  EnterpriceData as IntefaceEnterpriceData
} from '@/store/interfaces/company';
import { liquidationKind } from '@/store/interfaces/liquidations';
import companyTypes from '@/store/types/company';
import configurations from '@/store/types/configurations';
import liquidations from '@/store/types/liquidations';
import Vue, { PropType } from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import divider from '@/components/Reusable/divider.vue';

type valueName = {
  name: string;
  value: string;
};

export default Vue.extend({
  name: 'EnterpriceData',
  components: {
    aggregatorModel,
    IntermediarySelect,
    TaxpayerTypesSelect,
    divider,
  },
  props: {
    update: {
      required: false,
      default: false,
      type: Boolean,
    },
    enterpriseModel: {
      required: false,
      type: Object as PropType<IntefaceEnterpriceData>,
    },
  },
  data: () => ({
    model: {
      business_name: '',
      artificial_person: false,
      membership_status: 'inactive',
      membership_validation: 'no',
      taxpayer_type: 'non',
      state_code: '',
      business_turn: '',
      liquidation_kind_id: '',
      fixed_withholding: false,
      business_activity_summary: '',
      name: '',
      company_profile_id: '',
      billing_comment: '',
      intermediary_id: '',
    } as IntefaceEnterpriceData,
    default_type_artificial_person: 1,
    type_artificial_person: '',
    type_artificial_person_array: [
      {
        name: 'Natural',
        value: 'natural',
      },
      {
        name: 'Jurídica',
        value: 'juridica',
      }
    ] as valueName[],
    aggregatorModelData: {
      name: '',
      company_profile_id: '',
      fixed_withholding: false,
    } as AggregatorModel,
  }),
  computed: {
    ...mapGetters({
      getNewCompanyParams: `companyModule/${companyTypes.getters.GET_NEW_COMPANY_PARAMS}`,
      getCompaniesProprofileList: `companyModule/${companyTypes.getters.GET_COMPANIES_PROFILE_LIST}`,
      liquidationKindList: `liquidationModule/${liquidations.getters.GET_LIQUIDATION_KIND_LIST}`,
      hostConfig: `configurationModule/${configurations.getters.GET_HOST_CONFIGURATION}`,
    }),
    isAggregator(): boolean {
      const isAgg = this.liquidationKindList.data.some(
        (kind: liquidationKind) =>
          kind.id === this.model.liquidation_kind_id &&
          kind.slug === 'agregador'
      );
      return isAgg;
    },
  },
  async mounted(): Promise<void> {
    await this.companiesProfileList();
    this.assignModel();
    this.assignAggregatorModel();
  },
  methods: {
    ...mapActions({
      companiesProfileList: `companyModule/${companyTypes.actions.COMPANIES_PROFILE}`,
    }),
    ...mapMutations({
      setEnterpriceData: `companyModule/${companyTypes.mutations.SET_ENTERPRISE_DATA}`,
    }),
    assignAggregatorModel(): void {
      if (this.update) {
        this.aggregatorModelData = {
          name: this.enterpriseModel.name,
          company_profile_id: this.enterpriseModel.company_profile_id || '',
          fixed_withholding: this.enterpriseModel.fixed_withholding,
        };
      }
    },
    assignModel(): void {
      this.model = this.update
        ? this.enterpriseModel
        : this.getNewCompanyParams.model;

      if (!this.model.intermediary_id) {
        this.model.intermediary_id = '';
      }

      const artificial = this.model.artificial_person ? 'juridica' : 'natural';
      this.artificialPersonEvaluation(artificial);
    },
    artificialPersonEvaluation(value: string): void {
      if (value === 'juridica') {
        this.model.artificial_person = true;
        this.default_type_artificial_person = 2;
      } else {
        this.model.artificial_person = false;
        this.model.taxpayer_type = 'non';
        this.model.business_turn = '';
      }
    },
    changeValueOfAggregatorModel(val: boolean): void {
      if (val) {
        this.model.name = this.aggregatorModelData.name;
        this.model.company_profile_id =
          this.aggregatorModelData.company_profile_id;
        this.model.fixed_withholding =
          this.aggregatorModelData.fixed_withholding;
      } else {
        this.model.name = '';
        this.model.company_profile_id = '';
        this.model.fixed_withholding = false;
      }
    },
  },
  watch: {
    model: {
      immediate: true,
      deep: true,
      handler(val: IntefaceEnterpriceData): void {
        setTimeout(() => {
          if (this.update) {
            this.$emit('update:enterpriseModel', val);
          } else {
            this.setEnterpriceData(val);
          }
        }, 500);
      },
    },
    type_artificial_person: {
      immediate: true,
      deep: true,
      handler(val: string): void {
        this.artificialPersonEvaluation(val);
      },
    },
    isAggregator(val: boolean): void {
      this.changeValueOfAggregatorModel(val);
    },
  },
});
